export default "__VITE_ASSET__DPVMoki7__"